import { filter } from 'rxjs';

import { OnInit, Component, ViewEncapsulation } from '@angular/core';
import { Router, RouterOutlet, NavigationEnd } from '@angular/router';

import { AuthService } from '@/app/core/services/auth/auth.service';
import { ErrorStateService } from '@/app/core/services/error-state.service';

import { SidebarComponent } from '@/app/shared/components/layout/sidebar/sidebar.component';

@Component({
  selector: 'app-admin-layout',
  templateUrl: './admin-layout.component.html',
  styleUrl: './admin-layout.component.scss',
  encapsulation: ViewEncapsulation.None,
  imports: [RouterOutlet, SidebarComponent],
})
export class AdminLayoutComponent implements OnInit {
  constructor(
    protected router: Router,
    protected authService: AuthService,
    protected readonly errorStateService: ErrorStateService,
  ) {}

  ngOnInit(): void {
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      this.errorStateService.clearErrorMessage();
    });
  }
}
